import 'core-js/es';
import 'isomorphic-fetch';

import '../css/style.css';
import app from './components/app';
import initRiskified from './modules/initRiskified';
import config from '../../common/config';

if (typeof window !== 'undefined') {
    window.sendLog = logEvent => {
        if (!config.logger.logServerUrl) return;
        navigator.sendBeacon(
            config.logger.logServerUrl,
            JSON.stringify({
                level: 'warn',
                app: config.app.name,
                url: window.location.href,
                logEvent
            })
        );
    };

    window.onerror = (event, source, lineno, colno, error) => {
        window.sendLog({
            source, lineno, colno, err: error, event, mechanism: 'window.onerror'
        });
    };
}

document.addEventListener('DOMContentLoaded', () => {
    initRiskified();
    app();
}, false);
